import React from "react";
import { motion } from "framer-motion";
import {
  ArrowUpIcon,
  ArrowDownIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";

const variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  hover: { scale: 1.03, boxShadow: "0 4px 20px rgba(0,0,0,0.1)" },
};

const Card = ({
  title,
  value,
  icon: Icon,
  trend = "up",
  change = "+0.0%",
  color = "from-blue-500 to-indigo-500",
  period,
  isActive = false,
  compact = false,
  onClick
}) => {
  const isPositive = trend === "up";
  const trendColor = isPositive ? "text-green-600" : "text-red-600";
  const TrendIcon = isPositive ? ArrowUpIcon : ArrowDownIcon;

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      whileHover="hover"
      transition={{ duration: 0.4 }}
      className={`relative rounded-2xl p-4 cursor-pointer border backdrop-blur-md transition-all duration-300
        ${isActive ? 'border-indigo-500 bg-white/80 shadow-md dark:bg-gray-800/80' : 'border-white/10 bg-white/60 dark:bg-gray-800/60'}
      `}
      onClick={onClick}
    >
      <div className="flex flex-col h-full">
        <div className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 bg-gradient-to-br ${color} text-white`}>
          {Icon ? <Icon className="w-5 h-5" /> : <ClockIcon className="w-5 h-5" />}
        </div>
        <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{title}</h3>
        <p className={`text-xl font-bold ${compact ? 'text-base' : 'text-gray-900 dark:text-gray-100'} mb-2`}>
          {value}
        </p>
        <div className="mt-auto pt-2 border-t border-gray-100/50 dark:border-gray-700/50">
          <div className="flex items-center justify-between text-sm">
            <span className={`flex items-center font-medium ${trendColor}`}>
              <TrendIcon className="w-4 h-4 mr-1" />
              {change}
            </span>
            {period && <span className="text-xs text-gray-400">{period}</span>}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Card;
